export const ALERT_ORDINI = {
  'EVASIONE_OLTRE_24H': "Evasione oltre 24h",
  'RITARDO_EVASIONE_ORDINE': "Ritardo evasione ordine",
  'RITARDO_CARICAMENTO_BOZZE': "Bozza in ritardo",
  'MANCATA_APPROVAZIONE_BOZZE': "Mancata approvazione bozze",
  'PROBLEMA_DATA_FINE_LAVORI': "Problema data fine lavori",
  'OP3_INEVASI': "OP3 inevaso",
}

export const ALERT_ORDINI_CLIENTE = {
  'RITARDO_APPROVAZIONE_BOZZE': "Bozza non approvata",
}